import { createLoanAppConfig } from "@clcdev/gatsby-theme-application";
import meta from "./meta";

export default createLoanAppConfig(
    process.env.GATSBY_APP_CONFIG_VARIANT || "credit-chat",
    meta,
);